import { Tag, type TagVariantType } from "common/components/ui/Tag";
import usePromotions from "common/datahooks/usePromotions";
import useWorkspaces from "common/datahooks/useWorkspaces";

import PlanStatCard from "../../PlanStatCard";

interface AgencyLicenseSummaryProps {
  isCompact: boolean;
}

interface DetailCard {
  label: string;
  value: number;
  tagVariant: TagVariantType;
}

export default function AgencyLicenseSummary({
  isCompact,
}: AgencyLicenseSummaryProps) {
  const { agencyPlan } = usePromotions();
  const { workspaces } = useWorkspaces();

  const { unassigned_license_count: unassignedLicenseCount } = agencyPlan;

  // Calculate seats from workspace data, not promotion
  const assignedSeats = (workspaces ?? [])
    .filter(({ role }) => role === "owner")
    .reduce((sum, { agency_license_count }) => sum + agency_license_count, 0);
  const availableSeats = Math.max(unassignedLicenseCount, 0);
  const totalSeats = assignedSeats + availableSeats;

  const detailCards: DetailCard[] = [
    {
      label: isCompact ? "Total" : "Total seats",
      value: totalSeats,
      tagVariant: "tertiary",
    },
    {
      label: isCompact ? "Assigned" : "Allocated",
      value: assignedSeats,
      tagVariant: "secondary",
    },
    {
      label: "Available",
      value: availableSeats,
      tagVariant: "success",
    },
  ];

  return (
    <div className="grid sticky -top-16 z-10 grid-cols-1 md:grid-cols-2 max-lg:grid-rows-2 lg:gap-3 gap-2 lg:grid-cols-3">
      {detailCards.map(({ label, value, tagVariant }) => (
        <PlanStatCard title={label} key={label}>
          <Tag variant={tagVariant} size="md" className="w-fit">
            {value}
          </Tag>
        </PlanStatCard>
      ))}
    </div>
  );
}
